export default {
  'itemDetail.purchasedThisItem': '购买了此商品',
  'itemDetail.ProductDetailsPageSKUSelectionDrawer': '商品详情页_SKU选择抽屉',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerselectProducts':
    '商品详情页_SKU选择抽屉_选择商品',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerOKButton': '商品详情页_SKU选择抽屉_确定按钮',
  'itemDetail.ProductDetailsPageSKUSelectionDrawerChooseSubscriptionMode':
    '商品详情页_SKU选择抽屉_选择订阅模式',
  'itemDetail.FailedToCollectCouponPleaseTryAgainLater': '领券失败，请稍后再试',
  'itemDetail.hasBeenRemoved': '已下架',
  'itemDetail.NoAppointmentsYet': '暂无预约资格',
  'itemDetail.AppointmentSuccessfulViewDetails': '预约成功，查看详情',
  'itemDetail.willBe': '将于',
  'itemDetail.OnSale': '开售',
  'itemDetail.AppointmentSuccessful': '预约成功',
  'itemDetail.AppointmentFailed': '预约失败',
  'itemDetail.bookNow': '立即预约',
  'itemDetail.have': '已有',
  'itemDetail.TheAppointmentWasSuccessful': '人预约成功',
  'itemDetail.AppointmentNotStarted': '预约未开始',
  'itemDetail.startAnAppointment': '开始预约',
  'itemDetail.hasNotStarted': '未开始',
  'itemDetail.over': '已结束',
  'itemDetail.robbed': '已抢',
  'itemDetail.remaining': '剩余',
  'itemDetail.ProductDetailsPagebuyButton': '商品详情页_购买按钮',
  'itemDetail.BuyNow': '立即购买',
  'itemDetail.TheProductIsARestrictedProductYouCannotPurchaseItIfYouDoNotMeetTheRestrictedPurchaseConditions':
    '商品为限购商品，您不满足限购条件，无法购买',
  'itemDetail.snapUpNow': '立即抢购',
  'itemDetail.NotEligibleToGet': '暂无资格前往获取',
  'itemDetail.NotEligibleForRedemption': '暂无兑换资格',
  'itemDetail.SoldOut': '已售罄',
  'itemDetail.ChooseAnItem': '选择商品',
  'itemDetail.flashSale': '限时抢购',
  'itemDetail.GetItForFree': '免费领取',
  'itemDetail.RedeemNow': '立即兑换',
  'itemDetail.individualShopping': '单独购买',
  'itemDetail.InitiateAGroupPurchase': '发起团购',
  'itemDetail.PurchaseInInstallments': '分期购买',
  'itemDetail.afterCoupon': '券后',
  'itemDetail.Expect': '期',
  'itemDetail.Minute': '分',
  'itemDetail.day天hourminutesecond': '{day}天 {hour}:{minute}:{second}',
  'itemDetail.onlyLeftToEnd': '距结束仅剩',
  'itemDetail.MMMonthDDDayHHmm': 'MM月DD日HH:mm',
  'itemDetail.Finish': '结束',
  'itemDetail.immediateReduction': '立减',
  'itemDetail.PleaseSelectAnItem': '请选择商品',
  'itemDetail.InsufficientGrowthBeansGetItNow': '成长豆不足立即获取',
  'itemDetail.InsufficientBalanceOfGrowthBeans': '成长豆余额不足',
  'itemDetail.CouponPurchase': '领券购买',
  'itemDetail.Sure': '确定',
  'itemDetail.ChooseHowToBuy': '选择购买方式',
  'itemDetail.YouHaveAlreadyActivatedThisProductYouCannotChooseToSubscribe':
    '您已激活该商品，不可选择订阅',
  'itemDetail.YouAreAlreadySubscribedToThisItem': '您已订阅该商品',
  'itemDetail.ThisSubscriptionModelIsNotCurrentlySupported': '暂不支持该订阅模式',
  'itemDetail.oneTimePayment': '一次性支付',
  'itemDetail.specialPrice': '优惠价',
  'itemDetail.LimitedTimeOffer': '限时优惠',
  'itemDetail.ParameterError': '参数错误!',
  'itemDetail.share': '分享',
  'itemDetail.subscription': '订阅',
  'itemDetail.accordingTo': '按',
  'itemDetail.delivery': '配送',
  'itemDetail.ExpressDelivery': '快递配送',
  'itemDetail.illustrate': '说明',
  'itemDetail.callOfficial': '叫叫官方',
  'itemDetail.ProductDetailsPageCustomerServiceButton': '商品详情页_客服按钮',
  'itemDetail.customerService': '客服',
  'itemDetail.ActivitiesAndCouponsAreMutuallyExclusiveAndItIsMoreCostEffectiveToRecommendCoupons':
    '活动与优惠券互斥，推荐用券更划算',
  'itemDetail.selected': '已选',
  'itemDetail.HuabeiInstallmentoptional': '花呗分期（可选）',
  'itemDetail.perIssue': '/每期',
  'itemDetail.PurchaseQuantity': '购买数量',
  'itemDetail.goToView': '前往查看',
  'itemDetail.YouHaveParticipatedInTheGroupGroupActivityClickTheButtonBelowToViewTheGroupGroupProgress':
    '您已参加拼团活动,点击下方按钮查看拼团进度哦',
  'itemDetail.ProductDetailsPageretainPopUpExposure': '商品详情页_挽留 弹窗曝光',
  'itemDetail.mall': '商城',
  'itemDetail.ProductDetailsPageretainPopupContentButtonClick': '商品详情页_挽留弹窗内容按钮点击',
  'itemDetail.other': '其他',
  'itemDetail.ProductDetailsPageRetainTheButtonClickAtTheBottomOfThePopUpWindow':
    '商品详情页_挽留弹窗底部按钮点击'
};
